export default {
    namespaced: true,
    state: {
        equipos:{}
    },
    mutations: {
        SET_EQUIPOS(state, equipos){
            state.equipos = equipos;
        },
    },
    actions: {
        setEquipos({commit}, equipos){
            commit('SET_EQUIPOS', equipos);
        },
    }
}